import { API_URL } from '../../../app-config/constants';
import type ObjectiveBrowserView from '../../../types/ObjectiveBrowserView';
import { get } from '../request';

interface GetAllObjectivesOptions {
    ownerIds?: string[];
    cycleIds?: string[];
    /** Amount of objectives to load, between 0 and 1,000. */
    limit?: number;
    offset?: number;
    sortKey?: 'dueMonth';
}

getAllObjectives.operation = 'READ';
// MISSING: updateOnCreate
export function getAllObjectives(options?: GetAllObjectivesOptions) {
    return get<ObjectiveBrowserView[]>(`${API_URL}/objective-cycles/all/objectives/browse-view`, {
        getData: {
            ownerIds: options?.ownerIds?.join(','),
            cycleIds: options?.cycleIds?.join(','),
            limit: (options?.limit || 50).toString(),
            offset: options?.offset?.toString(),
            sortKey: options?.sortKey || 'dueMonth',
        },
    });
}

getAllObjectivesInCycle.operation = 'READ';
getAllObjectivesInCycle.updateOnCreate = ([cycleId]: [string], x: ObjectiveBrowserView, xs: ObjectiveBrowserView[]) => {
    if (x.cycleId === cycleId) {
        return [x, ...xs];
    }
};
export function getAllObjectivesInCycle(cycleId: string) {
    return get<ObjectiveBrowserView[]>(`${API_URL}/objective-cycles/${cycleId}/objectives`);
}

// ladda currently does not call updateOnCreate for sub-views,
// so this function needs to be called manually
notifyCreate.operation = 'CREATE';
export function notifyCreate(objective: ObjectiveBrowserView) {
    return Promise.resolve(objective);
}

notifyDelete.operation = 'DELETE';
notifyDelete.invalidates = ['getAllObjectivesInCycle', 'getAllObjectives'];
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function notifyDelete(objectiveId: string) {
    return Promise.resolve();
}
